module.exports = __webpack_public_path__ + "media/images/flags/bi-3fce551eeb9f82d29f7683f31173db5e.svg";